import React from "react";
import PeopleIcon from "@mui/icons-material/People";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BarChartIcon from "@mui/icons-material/BarChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

export const STAT_CARD_ICONS: Record<string, React.ComponentType> = {
  total_users: PeopleIcon,
  active_users: CheckCircleIcon,
  participation_rate: BarChartIcon,
  completion_rate: TrendingUpIcon,
};

export const getStatCardIcon = (metricKey: string): React.ComponentType => {
  return STAT_CARD_ICONS[metricKey] || BarChartIcon;
};
